import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IChangeAgentCheckItem, IChangeAgentCheckParam, IChangeAgentParam, IChangeAgentRecord } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 系统管理 - 更换代理商 - 获取分页列表
 */
export async function queryChangeAgentList(params: IChangeAgentParam) {
  let total = 0;
  let data = [] as IChangeAgentRecord[];

  try {
    const { code, context, message } = await Http.post<{ data: IChangeAgentRecord[]; total: number }>(
      `${hostUrl}/side/change-side-belong/company-change-agent/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as { data: IChangeAgentRecord[]; total: number };

      data = res.data || [];
      total = res.total || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 系统管理 - 更换代理商 - 导出
 */
export async function exportChangeAgentList(params: IChangeAgentParam) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/side/change-side-belong/company-change-agent/page-export`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 系统管理 - 更换代理商 - 企业变更代理商-校验
 */
export async function queryChangeAgentCheck(params: IChangeAgentCheckParam) {
  let data = [] as IChangeAgentCheckItem[];

  try {
    const { code, context, message } = await Http.post<{ checkItems: IChangeAgentCheckItem[] }>(
      `${hostUrl}/side/change-side-belong/company-change-agent/check`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as { checkItems: IChangeAgentCheckItem[] };

      data = res.checkItems || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 系统管理 - 更换代理商 - 企业变更代理商-导出
 */
export async function exportChangeAgentCheck(params: IChangeAgentCheckParam) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/side/change-side-belong/company-change-agent/check-export`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 系统管理 - 代理商更换等级 - 确认
 */
export async function confirmChangeAgent(params: IChangeAgentCheckParam) {
  let text = undefined;
  
  try {
    const { code, context, message } = await Http.post(
      `${hostUrl}/side/change/agent-belong/change-level-confirm`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      text = context || undefined;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return text;
}

/**
 * 系统管理 - 更换代理商 - 企业变更代理商-确认
 */
export async function confirmCompanyChangeAgent(params: IChangeAgentCheckParam) {
  let text = undefined;
  
  try {
    const { code, context, message } = await Http.post(
      `${hostUrl}/side/change-side-belong/company-change-agent/confirm`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      text = context || undefined;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return text;
}